import { RootState } from 'editor/src/store/index';

import getGalleryImages from './getGalleryImages';

const getGalleryImagesCount = (state: RootState) => getGalleryImages(state).length;

export default getGalleryImagesCount;
